export default __webpack_public_path__ + "static/media/error.3750d6e1.svg";